export const Images = {
  MAIN_LOGO: require("./logos/aficor.svg").default,
  WIP: require("./icons/wip.svg").default,
  LANG: require("./icons/language.svg").default,

  ARROW_BACK: require("./icons/arrow-back.svg").default,
  ARROW_DOWN: require("./icons/arrow-down.svg").default,

  FACEBOOK: require("./icons/facebook.svg").default,
  INSTAGRAM: require("./icons/instagram.svg").default,
  YOUTUBE: require("./icons/youtube.svg").default,

  HOME_BG_IMAGE: require("./images/home.png"),
  CONTACT_BG_IMAGE: require("./images/contact.jpeg"),
  HYDRAULIQUE_BG_IMAGE: require("./images/hydraulique.png"),
  OXYCOUPAGE_BG_IMAGE: require("./images/oxycoupage.png"),
  RD_BG_IMAGE: require("./images/r&d.png"),
  US_BG_IMAGE: require("./images/us.jpeg"),
  MACHINES_BG_IMAGE: require("./images/machines.jpeg"),
  BUCHES: require("./images/buches.jpeg"),

  BUTTON_LINK: require("./icons/button-link.svg").default,
  ORANGE_STREAKS: require("./images/orange-streaks.svg").default,
  STAR: require("./icons/star.svg").default,
  ORANGE_STAR: require("./icons/orange-star.svg").default,

  CFF: require("./logos/cff.svg").default,
  CHEYRES: require("./logos/cheyres-chables.svg").default,
  CHEVROUX: require("./logos/chevroux.png"),
  LANDERON: require("./logos/landeron.png"),
  FERRING: require("./logos/ferring.png"),
  HERAUS: require("./logos/heraus.png"),
  MICARNA: require("./logos/micarna.png"),
  BADER: require("./logos/bader.png"),
  NEUWERTH: require("./logos/neuwerth.png"),
  LIDL: require("./logos/lidl.png"),
  JNJ: require("./logos/jnj.jpeg"),
  CREABETON: require("./logos/creabeton.jpg"),
  ABAGEOL: require("./logos/abageol.jpg"),
  // PAUL_GENILLOUD: require("./logos/paul_genilloud.png"),
  ISR: require("./logos/isr.png"),

  LOCATION: require("./icons/location.svg").default,
  PHONE: require("./icons/phone.svg").default,
  MAIL: require("./icons/mail.svg").default,
  MESSAGE: require("./icons/message.svg").default,

  WHITE_TICK: require("./icons/whiteTick.svg").default,
  ORANGE_TICK: require("./icons/orangeTick.svg").default,

  RD_1: require("./images/r&d_1.jpeg"),
  VIEW_MORE: require("./icons/view-more.svg").default,

  PROJECT1_PICTURE1: require("./images/projects/Enrouleuse/Picture1.png"),
  PROJECT1_PICTURE2: require("./images/projects/Enrouleuse/Picture2.png"),
  PROJECT1_PICTURE3: require("./images/projects/Enrouleuse/Picture3.png"),
  PROJECT2_PICTURE1: require("./images/projects/AFIRAIN130-400/Picture1.png"),
  PROJECT2_PICTURE2: require("./images/projects/AFIRAIN130-400/Picture2.png"),
  PROJECT2_PICTURE3: require("./images/projects/AFIRAIN130-400/Picture3.png"),
  PROJECT3_PICTURE1: require("./images/projects/Xylochips/Picture1.jpg"),
  PROJECT3_PICTURE2: require("./images/projects/Xylochips/Picture2.jpg"),
  PROJECT3_PICTURE3: require("./images/projects/Xylochips/Picture3.png"),
  PROJECT4_PICTURE1: require("./images/projects/Landeron/Picture1.png"),
  PROJECT4_PICTURE2: require("./images/projects/Landeron/Picture2.png"),
  PROJECT4_PICTURE3: require("./images/projects/Landeron/Picture3.png"),

  MACHINE_1: require("./images/nos_machines/machine_1.png"),

  PREAMBULE: require("./images/histoire/preambule.webp"),
  TUNING_TRACTEUR: require("./images/histoire/tuning_tracteur.webp"),
  ARRACHEUSE_PATATE: require("./images/histoire/arracheuse_patate.webp"),
  TRACTEUR_40CH: require("./images/histoire/tracteur_40ch.webp"),
  CHARS_BASCULANTS: require("./images/histoire/chars_basculants.webp"),
  CONSTRUCTION_FERME: require("./images/histoire/construction_ferme.webp"),
  CONCOURS: require("./images/histoire/concours.webp"),
  BIG_ARROW: require("./images/big-arrow.svg").default,
};
